enum ProductCardMediaEnum {
	singleImage = 'singleImage',
	switchImageOnHover = 'switchImageOnHover',
	carousel = 'carousel'
}
export default ProductCardMediaEnum;
